import gql from 'graphql-tag';

export default gql`
    query CheckIsJobAccessible($input: CheckIsJobAccessibleInput) {
        checkIsJobAccessible(input: $input) {
            isAccessible
        }
    }
`;
